<div class="sidenav-container" [@onSideNavChange]="sideNavState ? 'open' : 'close'">
  <div class="sidenav" [ngClass]="classFlag ? 'sidenav-responsive' : ''">
    <div>
      @if (!classFlag) {
        <img [routerLink]="['/dashboard']" src="../../../assets/images/bas-logo.svg" alt=""
          class="favicon">
      }
    </div>
    @if (classFlag) {
      <div class="sidebar-header">
        <img class="ml-auto" src="../../../assets/images/close-circle.svg" (click)="closed(router.url)" />
      </div>
    }
    <div class="module-container">
      <mat-nav-list disableRipple>
        @for (module of modules; track module) {
          <mat-list-item class="side-menu">
            <a (click)="closed(module.routerLink)" routerLink="{{module.routerLink}}" class="module-text text"
              [ngClass]="{'active' : checkActiveRoute(module.identifier)}">
              @if (!classFlag) {
                <div class="hover">
                  <img src="assets/images/{{module.menuIcon}}-icon.svg" alt="" class="icon iconClass">
                  <div>
                    <p class="menu-name">{{module.module_name}}</p>
                  </div>
                  <span class="side-menu-text" [@animateText]="linkText ? 'show' : 'hide'">{{
                    module.module_name }}
                  </span>
                </div>
              }
              @if (classFlag) {
                <div class="hover">
                  <div style="margin-left: 15%;">
                    <img src="assets/images/{{module.menuIcon}}-icon.svg" alt="" class="icon">
                  </div>
                  <div style="margin-left: 7%;align-self: center;">
                    <span class="side-menu-text" [@animateText]="linkText ? 'show' : 'hide'">{{
                      module.module_name }}
                    </span>
                  </div>
                </div>
              }
            </a>
          </mat-list-item>
        }
      </mat-nav-list>
    </div>
  </div>
</div>